module.exports = __webpack_public_path__ + "img/round2-iteration6.f2aa1d78.gif";